import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "login-grid" }
const _hoisted_2 = { class: "form-row" }
const _hoisted_3 = { class: "loginForm" }
const _hoisted_4 = {
  key: 0,
  class: "loginError"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "row" }, [
      _createElementVNode("h1", { class: "title" }, "Hi! We’re glad you’re here.")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("h2", null, "Here for class?", -1)),
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logIn && _ctx.logIn(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "Username",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event))
          }, null, 512), [
            [_vModelText, _ctx.username]
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
          _withDirectives(_createElementVNode("input", {
            type: "password",
            placeholder: "Password",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event))
          }, null, 512), [
            [_vModelText, _ctx.password]
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
          (_ctx.loginError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.loginError.alert), 1))
            : _createCommentVNode("", true),
          _cache[5] || (_cache[5] = _createElementVNode("button", null, "Sign In", -1))
        ], 32)
      ])
    ]),
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "row" }, [
      _createElementVNode("h2", null, "Want to know more?"),
      _createElementVNode("p", null, " Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore sequi natus delectus eligendi similique quia aperiam hic alias id sit tempora molestias rerum dolorem omnis recusandae, vel soluta officia voluptate! ")
    ], -1))
  ]))
}